// extracted by mini-css-extract-plugin
export default {"description":"style_description__Tui5o","fade-in":"style_fade-in__LAEvR","top":"style_top__YhbDM","image":"style_image__PmcVf"};